
import MapStyle from './map-styles';

export default {
    center: {
        lat: 60.472,
        lng: 8.4689,
    },
    zoom: 5,
    disableDefaultUI: false,
    streetViewControl: false,
    panControl: true,
    mapTypeControl: false,
    scrollwheel: false,
    navigationControl: false,
    scaleControl: true,
    fullscreenControl: false,
    // styles: MapStyle,
    backgroundColor: 'rgba(0, 0, 0, 0)',
};
